export function toggleDisabledAttribute(fields, removeFlag) {
  if (removeFlag) {
    fields.prop('disabled', true).prop('checked', false);
  } else {
    fields.prop('disabled', false);
  }
}